import * as React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const SectionCorousel = ({ items, className = "" }) => {
  return (
    <div
      className={`relative w-full max-w-full px-4 sm:px-8 md:px-12 ${className}`.trim()}
    >
      <Carousel
        className="w-full relative"
        opts={{
          align: "start",
          loop: true,
          direction: "ltr",
          containScroll: "trimSnaps",
          slidesToScroll: 1,
          dragFree: false,
          skipSnaps: false,
          inViewThreshold: 0.3,
          startIndex: 0,
        }}
      >
        <CarouselContent className="flex gap-4 items-center">
          {items.map((content, index) => (
            <CarouselItem
              key={index}
              className="flex-shrink-0 flex justify-center basis-auto"
              style={{
                width: "280px",
                minWidth: "280px",
                maxWidth: "280px",
              }}
            >
              <div className="w-full h-full flex justify-center">
                <CarouselCard index={index + 1} content={content} />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>

        {items?.length > 1 && (
          <>
            <CarouselPrevious className="flex -left-2 sm:-left-6 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white border border-[#DFE6FF] shadow-lg hover:bg-gray-50 items-center justify-center z-10" />
            <CarouselNext className="flex -right-2 sm:-right-6 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white border border-[#DFE6FF] shadow-lg hover:bg-gray-50 items-center justify-center z-10" />
          </>
        )}
      </Carousel>
    </div>
  );
};

const CarouselCard = ({ index, content }) => (
  <div className="snap-center flex-shrink-0 w-[270px] h-[170px] sm:h-[191px] p-3 sm:p-4 bg-white rounded-[20px] border border-[#E4E8FF] flex flex-col items-center justify-center mb-6 sm:mb-0">
    <div className="flex justify-center mb-3 sm:mb-4">
      <div className="w-7 h-7 sm:w-10 sm:h-10 rounded-[20px] bg-[#0EBE7F] text-white flex items-center justify-center font-bold text-sm sm:text-lg shadow-[inset_0_4px_4px_rgba(0,0,0,0.25)]">
        {index}
      </div>
    </div>
    <p className="font-poppins font-medium text-[10px] sm:text-[12px] leading-[18px] sm:leading-[24px] tracking-[0.04em] text-[#9AA3B7] text-center px-1 sm:px-2">
      {content}
    </p>
  </div>
);

export default SectionCorousel;
